export const cookieConsent = 'cookieyes-consent';
